import * as React from "react";
import { NextActionLink } from "source/app/presentation/BottomBar/BottomLeftDashboard/NextActionLink/NextActionLink";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import { Fonts } from "source/app/presentation/Shared/Styles/SharedStyles";

export function BottomLeftDashboard({
}: {
}) {
    return (
        <span
            {...Style(`bottomLeftDashboard`, {
                zIndex: 1,
                display: "inline-flex",
                alignItems: "center",
                transform: "translateY(4px)",
                ...Fonts.iMFell,
                background: "rgba(0,0,0,0.14)",
                backdropFilter: "blur(2px)",
                WebkitBackdropFilter: "blur(2px)",
                padding: "4px 2px 4px 2px",
                borderRadius: "3px",
            })}
        >
            <NextActionLink />
        </span>
    );
}
